import type { WalletReadyState } from './WalletButtonShell';

/**
 * Composes the `wallet-pair` wrapper class from the Stripe ECE ready
 * state. `is-ready` / `is-unavailable` are stable hooks for CSS to
 * crossfade the layered placeholder vs. real button, so isolating the
 * mapping here keeps the component JSX focused and the class set
 * trivially testable.
 */
export const getWalletPairClass = (state: WalletReadyState): string => {
  // `is-visual-proxy` is always on for the Stripe ECE pair: the real ECE
  // buttons paint at Stripe's own size/radius (48px, near-square corners),
  // which never matched the Figma 44px/8px design. So we keep the branded
  // placeholders as the VISIBLE button and keep the real (invisible) ECE
  // layer as the click target only. See `.wallet-pair.is-visual-proxy` in
  // walletButton.css.
  const parts = ['wallet-pair', 'is-visual-proxy'];
  if (state === 'ready') parts.push('is-ready');
  if (state === 'unavailable') parts.push('is-unavailable');
  return parts.join(' ');
};
